import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  variant?: 'default' | 'compact' | 'hero';
}

export default function MovieCard({ movie, variant = 'default' }: MovieCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/movie/${movie.id}`}
        className="group flex gap-3 p-3 rounded-lg bg-background-100 hover:bg-background-200/70 transition-all duration-200 cursor-pointer"
      >
        <div className="w-16 h-24 flex-shrink-0 rounded-md overflow-hidden">
          <img
            src={movie.imageUrl}
            alt={movie.title}
            title={`${movie.title} - 星空电影网`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
        </div>
        <div className="flex flex-col justify-between min-w-0">
          <div>
            <h4 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors truncate">
              {movie.title}
            </h4>
            <p className="text-xs text-foreground-500 mt-1">
              {movie.year} · {movie.duration}
            </p>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-primary-500 text-xs"></i>
            <span className="text-xs text-primary-400 font-medium">{movie.rating}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.imageUrl}
          alt={movie.title}
          title={`${movie.title} - 星空电影网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>

        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {movie.isNew && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-white">
              最新
            </span>
          )}
          {movie.isHot && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-background-950">
              热门
            </span>
          )}
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-1 mb-1">
            <i className="ri-star-fill text-primary-500 text-sm"></i>
            <span className="text-sm text-primary-400 font-semibold">{movie.rating}</span>
          </div>
          <h3 className="text-base font-heading font-semibold text-white group-hover:text-primary-400 transition-colors truncate">
            {movie.title}
          </h3>
          <p className="text-xs text-foreground-300 mt-0.5">
            {movie.year} · {movie.category} · {movie.duration}
          </p>
        </div>
      </div>
    </Link>
  );
}